const steps = [
  { num: '1', title: 'Диагностика', desc: 'Понимаем, какие изменения происходят в компании и где возникают основные проблемы для руководителей и команды.' },
  { num: '2', title: 'Настройка программы', desc: 'Адаптируем обучение под компанию, участников и конкретные изменения, которые она переживает.' },
  { num: '3', title: 'Практическое обучение', desc: 'Разбираем управленческие инструменты: коммуникация изменений, работа с сопротивлением, закрепление нового поведения.' },
  { num: '4', title: 'Отработка', desc: 'Тренируем коммуникацию, работу с сопротивлением и сложные ситуации на реальных примерах участников.' },
  { num: '5', title: 'Внедрение', desc: 'Руководители применяют инструменты в реальной работе и проводят изменения в своей зоне ответственности.' },
  { num: '6', title: 'Сопровождение', desc: 'При необходимости разбираем возникающие сложности после обучения и поддерживаем внедрение.' },
  { num: '7', title: 'Оценка изменений', desc: 'Определяем, какие изменения произошли в управленческом поведении и процессах компании.' },
];

export default function HowProgramGoes() {
  return (
    <section id="process" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как строится программа
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          От диагностики до закрепления изменений — семь этапов, которые обеспечивают перенос инструментов в реальную работу
        </p>

        <div className="relative">
          <div className="hidden lg:block absolute left-[23px] top-8 bottom-8 w-0.5 bg-teal-200"></div>
          <div className="space-y-5">
            {steps.map((step) => (
              <div key={step.num} className="flex gap-5 items-start relative">
                <div className="w-12 h-12 rounded-full bg-teal-600 text-white flex items-center justify-center text-lg font-bold flex-shrink-0 z-10">
                  {step.num}
                </div>
                <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 flex-1 hover:border-teal-300 transition-colors">
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5">{step.title}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}